<template>
  <div>
    <div class="pc-swiper-container">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide v-for="(item, index) in imgList" :key="index" >
          <img class="slideImg" :src="item.img">
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </div>
    <div class="ph-swiper-container" style="padding-top: 20px">
      <swiper class="swiper" :options="phswiperOption">
        <swiper-slide v-for="(item, index) in imgList" :key="index" >
          <img class="slideImg" :src="item.img">
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'swiper-example-multiple-slides-per-biew',
  components: {
    swiper,
    swiperSlide
  },
  props: {
    imgList: {
      type: Array
    }
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 99,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      phswiperOption: {
        slidesPerView: 4,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
.pc-swiper-container {
  width: 100%;
  position: relative;
  margin-top: 100px;
  .swiper{
    width: 90%;
  }
  ::v-deep{
    .swiper-slide{
      height: 142px;
    }
    .swiper-wrapper{
      box-sizing: border-box;
    }
    .swiper-button-prev{
      background-image: url('https://qingbo-oss.oss-cn-beijing.aliyuncs.com/158a607c-5650-4798-a05a-10ab449dd237.png');
      background-size: 14px 24px;
      outline: none;
    }
    .swiper-button-next{
      background-image: url('https://qingbo-oss.oss-cn-beijing.aliyuncs.com/71e3b071-1996-4228-92a7-1acf9226b60a.png');
      background-size: 14px 24px;
      outline: none;
    }
  }
}
.slideImg{
  width: 142px;
  height: 142px;
}
.ph-swiper-container{
  display: none;
 .slideImg{
    width: 81px;
    height: 81px;
  }
}
@media(max-width: 992px) {
  .pc-swiper-container{
    display: none;
  }
  .ph-swiper-container{
    display: block !important;
  }
}
</style>
